<app-modal [open]="active" [size]="'xl'" [name]="'sign-atp'" (close)="closeDialog()">
  <div modal-header>Sign ATP</div>
  <div modal-body>
    <iframe *ngIf="atpDocumentPath" [src]="atpDocumentPath" width="100%" height="550px"></iframe>
    <ng-container>
      <h3>e-Signature</h3>

      <div>
        <div class="signup-body mb-10">
          Typing your name as it exactly appears below signifies you are
          completing this form using an electronic signature. By electronically
          signing, you are certifying that you have read and understood
          CREtelligent’s Terms and Conditions shown above.
        </div>
        <form [formGroup]="signedAtpDetails">
          <div class="signature">
            <div class="form-control">
              <label for="fullName" class="form-label"
                >Full Name <span class="req">* </span
                ><span
                  *ngIf="
                    signedAtpDetails.controls['fullName']?.invalid &&
                    (signedAtpDetails.controls['fullName'].dirty ||
                      signedAtpDetails.controls['fullName'].touched)
                  "
                >
                  <span
                    *ngIf="signedAtpDetails.controls['fullName'].errors?.['required']"
                    class="error-message"
                  >
                    Name is required.
                  </span>
                </span></label
              ><br />
              <input
                type="text"
                class="emailinput"
                id="fullName"
                formControlName="fullName"
                data-testid="sign-atp-full-name"
              />
            </div>
            <div class="form-control">
              <label for="signedDate" class="form-label">Date of Signing</label>
              <br />
              <input
                disabled
                [value]="formattedDate"
                type="text"
                class="dateofsign"
                id="signedDate"
                data-testid="sign-atp-signed-date"
              />
            </div>
          </div>
        </form>
      </div>
    </ng-container>
  </div>

  <button
    modal-footer
    type="button"
    class="btn btn--primary"
    data-testid="sign-atp-sign"
    [disabled]="disableSubmitButton"
    (click)="submit()"
  >
    Agree & Sign Electronically
  </button>
  <button
    modal-footer
    type="button"
    class="btn btn--secondary"
    data-testid="sign-atp-cancel"
    [attr.aria-disabled]="locked"
    [matTooltip]="lockedReason"
    [matTooltipDisabled]="!locked"
    matTooltipTouchGestures="off"
    (click)="onDeclineClick()"
  >
    Decline
  </button>
</app-modal>

<decline-dialog
  [active]="isDeclineActive"
  [siteType]="siteType"
  [siteSubType]="siteSubType"
  [address]="address"
  [isAtp]="true"
  (modalClosed)="toggleDeclineModal()"
  (decline)="declineAtp($event)"
></decline-dialog>
